import React, { Component } from "react";
//// componentes reutilizables

import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import TransferenciasService from "../../../../services/transferencias/TransferenciasService";
import {
  formatoSeparadorMilesReturn,
  splitImporte,
} from "../../../generico/utils/FormatoInput";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class TransferenciaInterbancaria extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    monto: 0,
    motivo: "",
    nroOperacion: 0,
    disableSgte: true,
    otrosDesc: "",
    listaMotivos: []
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.obtenerMotivosTransferencia();
  };

  componentDidMount() {
    this.obtenerMotivosTransferencia();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerMotivosTransferencia = () => {
    trackPromise(
      TransferenciasService.getMotivosTransferencia()
        .then(({ data }) => {
          if (data.codigo === 0) {

            this.setState({ listaMotivos: data.datos });

          } else {
            console.log(data);
          }
        })
        .catch(error => {
          console.log(error);
        })
    )
  }

  enableNext(monto, motivo, otrosDesc) {
    if (monto !== "") {
      if (motivo !== "" && motivo !== "Otros") {
        this.state.disableSgte = false;
      } else {
        if (motivo === "Otros" && otrosDesc !== "") {
          this.state.disableSgte = false;
        } else {
          this.state.disableSgte = true;
        }
      }

    } else {
      this.state.disableSgte = true;
    }
  }

  render() {
    return (
      <div>
        <form id="idFormPaso2" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row justify-content-md-center">
            <div className="col-lg-6 col-md-10">
              <div className="form-group">
                <label className="input-label-bold">Importe a Transferir *</label>
                <input
                  value={this.state.monto}
                  type="text"
                  maxLength="19"
                  name="monto"
                  className="form-control input-box"
                  onChange={(evt) => {
                    var _monto = formatoSeparadorMilesReturn(evt);
                    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                      _monto = _monto.substr(1);
                    }
                    this.setState({
                      monto: _monto,
                    });
                    _monto = splitImporte(_monto);
                    this.enableNext(parseFloat(_monto), this.state.motivo, this.state.otrosDesc);
                  }}
                />
              </div>
              <div className="form-group">
                <label className="input-label-bold">
                  Motivo de la Transferencia *
                </label>
                <select
                  value={this.state.motivo}
                  className="form-control input-box"
                  onChange={(evt) => {
                    this.setState({ motivo: evt.target.value, });
                    this.enableNext(this.state.monto, evt.target.value, this.state.otrosDesc);
                  }}
                >
                  <option key="-1" value="" disabled>--Seleccione--</option>
                  {
                    this.state.listaMotivos.map((motivo, index) => (
                      <option value={motivo} key={index}>{motivo}</option>
                    ))
                  }
                </select>
              </div>

              <div className="form-group">
                {this.state.motivo === "Otros" && (
                  <textarea
                    rows="4"
                    cols="50"
                    value={this.state.otrosDesc}
                    name="otrosDsc"
                    className="form-control input-box"
                    onChange={(evt) => {
                      this.setState({ otrosDesc: evt.currentTarget.value });
                      this.enableNext(this.state.monto, this.state.motivo, evt.currentTarget.value);
                    }}
                  ></textarea>
                )}
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-lg-8 col-md-6">
                <label
                  className="input-label-bold-obligatorio float-left">
                  (*) Campos Obligatorios
                  <br />
                </label>
                </div>
            <div className="col-lg-2 col-md-3">
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={() => {
                    this.props.previousStep();
                  }}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>
               
            </div>
            <div className="col-lg-2 col-md-3">
            <button
                  className="btn btn-cu-primary"
                  disabled={this.state.disableSgte}
                  onClick={() => {
                    var _motivo = (this.state.motivo === "Otros" ? this.state.otrosDesc : this.state.motivo)
                    this.props.returnDataPaso2(this.state.monto, _motivo);
                    if (this.props.currentStep === 2) {
                      this.props.nextStep();
                    }
                  }}
                >
                  Continuar <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
          
          </div>
        </form>
      </div>
    );
  }
}
